import { useMe } from '@hooks/getQueries';
import { Navigate } from 'react-router-dom';
import useSession from '../hooks/useSession';

const MfaSetupRoute = ({ children }) => {
  const { isAuthenticated, loading: authLoading } = useSession();
  const { data: me, isPending: meLoading } = useMe(isAuthenticated);

  if (authLoading || (isAuthenticated && meLoading)) {
    return <></>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (me && !me.mfa_setup_required) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default MfaSetupRoute;
